import { render, staticRenderFns } from "./modificaPraticaAvanzata.vue?vue&type=template&id=79d58ed4&scoped=true&"
import script from "./modificaPraticaAvanzata.vue.ts?vue&type=script&lang=ts&"
export * from "./modificaPraticaAvanzata.vue.ts?vue&type=script&lang=ts&"
import style0 from "./modificaPraticaAvanzata.vue?vue&type=style&index=0&id=79d58ed4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d58ed4",
  null
  
)

export default component.exports